import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_roster_live_session_path } from '@/modules/routes';
import sortStudentsByFirstName from '../sortStudentsByFirstName';

export interface RosterStudent {
  id: number;
  first_name: string;
  last_name: string;
  full_name: string;
  initials: string;
}

export interface RosterResponse {
  data: {
    students: RosterStudent[];
    connected_ids: number[];
    invited_ids: number[];
  };
}

// AIDEV-NOTE: PLAT-16888 — Fetches the live session's classroom roster + initial connected ids.
// After the initial fetch, real-time movement between Joined / Not Yet Joined is driven by
// student_count_changed broadcasts (LiveSessionChannel) — we do NOT refetch on count change.
// PLAT-17342 — Sort A-Z by first name once here so the panel can splice broadcast updates
// directly without re-sorting, and so the modal and panel share the same ordering rule.
export const useStudentsRoster = (sessionId: string | null | undefined, enabled = true) => (
  useQuery({
    enabled: !!sessionId && enabled,
    queryFn: () => axios
      .get<RosterResponse>(plato_api_roster_live_session_path(sessionId!))
      .then(res => ({
        ...res.data.data,
        students: sortStudentsByFirstName(res.data.data.students),
      })),
    queryKey: ['live_session_roster', sessionId],
    staleTime: Infinity,
  })
);
